import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomerProductPropertiesItem = _resolveComponent("CustomerProductPropertiesItem")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productProperties, (productProperty, index) => {
    return (_openBlock(), _createBlock(_component_CustomerProductPropertiesItem, {
      key: productProperty.property_type_code,
      errors: _ctx.errors,
      modelValue: _ctx.productProperties[index],
      "onUpdate:modelValue": [($event: any) => ((_ctx.productProperties[index]) = $event), _ctx.emitNewValue]
    }, null, 8, ["errors", "modelValue", "onUpdate:modelValue"]))
  }), 128))
}